import Clazz from './clazz';

export default class Grade {
    public gradeId:string;
    public gradeCode:string;
    public gradeName:string;
    public zoneId:string;
    public zoneName:string;
    public clazzList:Clazz[];
    constructor({
        gradeId = '',
        gradeCode = '',
        gradeName = '',
        zoneId = '',
        zoneName = '',
        clazzList = [],
    }={}) {
        this.gradeId =gradeId ;
        this.gradeCode =gradeCode ;
        this.gradeName = gradeName;
        this.zoneId = zoneId;
        this.zoneName = zoneName;
        this.clazzList = clazzList||[];
    }
}